const config = {
    backend_ip: process.env.REACT_APP_BACKEND_IP,
    socket_url: process.env.REACT_APP_SOCKET_URL,
    maintenance_mode: false,
    allowed_maintenance_view: ['maria_zefiro', 'marcusvinicius_estag']
};

export default config;